<template>
    <div class="body-time-cross">
        <div class="border-time-cross">
            <div class="date-items">
                <div class="item-date">{{ textStartDate }}</div>
                <div class="item-date">{{ textEndDate }}</div>
            </div>

            <div class="scroll-box">
                <div class="scroll-start">
                    <div class="start-hour">
                        <ScrollModule :items="hours" :selected="start.hour" @submitEvent="setStart($event,'hour')"/>
                    </div>
                    <div class="text-center">:</div>
                    <div class="start-minute">
                        <ScrollModule :items="minutes" :selected="start.minute" @submitEvent="setStart($event,'minute')"/>
                    </div>
                </div>
                <div class="coupling">-</div>
                <div class="scroll-end">
                    <div class="end-hour">
                        <ScrollModule :items="hours" :selected="end.hour" @submitEvent="setEnd($event,'hour')"/>
                    </div>
                    <div class="text-center">:</div>
                    <div class="end-minute">
                        <ScrollModule :items="minutes" :selected="end.minute" @submitEvent="setEnd($event,'minute')"/>
                    </div>
                </div>
            </div>

            <div class="button-items">
                <div class="button-close my-cursor" @click.stop="close">取消</div>
                <div class="button-submit my-cursor" @click.stop="submit">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from './ScrollModule';
import initData from "@/utils/initData";

export default {
    name: "TimeCross",
    components: {
        ScrollModule
    },
    data(){
        return {
            start: {
                hour: "00",
                minute: "00"
            },
            end: {
                hour: "00",
                minute: "00"
            },
            hours: initData.hours,
            minutes: initData.minutes,
            textStartDate: "",
            textEndDate: "",
        }
    },
    props: {
        startDate: {
            type: String,
            default: "",
        },
        endDate: {
            type: String,
            default: "",
        },
        startTime: {
            type: Number,
            default: -1,
        },
        endTime: {
            type: Number,
            default: -1,
        },
    },
    methods: {
        close: function(){
            this.$emit("closeEvent");
        },
        submit: function(){
            this.$emit("submitEvent", {start: this.start, end: this.end});
            this.close();
        },
        setStart: function(e, valueType){
            if(valueType === "hour"){
                this.start.hour = e;
            }else{
                this.start.minute = e;
            }
        },
        setEnd: function(e, valueType){
            if(valueType === "hour"){
                this.end.hour = e;
            }else{
                this.end.minute = e;
            }
        },

    },
    mounted: function(){
        if(this.startTime === -1){
            const currentTime = new Date();
            this.end = {
                hour: this.$Utils.addZero(currentTime.getHours()),
                minute: this.$Utils.addZero(currentTime.getMinutes()),
            }
            this.start ={
                hour: this.$Utils.addZero(currentTime.getHours()),
                minute: this.$Utils.addZero(currentTime.getMinutes()),
            }
        }else{
            this.start = this.$Utils.minuteToTime(this.startTime);
            this.end = this.$Utils.minuteToTime(this.endTime);
        }
        this.textStartDate = this.$Utils.getDateStr(this.startDate);
        this.textEndDate = this.$Utils.getDateStr(this.endDate);
    }
}
</script>

<style scoped>
div.body-time-cross{
    width: 4.2rem;
    height: auto;
    padding: 0.08rem;
    background: #FFFFFF;
    border-radius: 0.3rem;
    margin: 20vh auto auto;
}

div.border-time-cross{
    width: 100%;
    height: auto;
    padding: 0.16rem 0.2rem 0.3rem;
    border: 0.02rem solid #000000;
    border-radius: 0.26rem;
    box-sizing: border-box;
}
div.date-items{
    width: 100%;
    display: flex;
    gap: 0.7rem;
    justify-content: center;
    box-sizing: border-box;
}
div.item-date{
    font-weight: bold;
    font-size: 0.18rem;
    color: #FC8470;
    line-height: 0.22rem;
    text-align: center;
}
div.scroll-box{
    width: 100%;
    height: 1.7rem;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    margin-top: 0.2rem;

    box-sizing: border-box;
    padding: 0.23rem 0.3rem;

    display: flex;
    align-items: center;
}
div.scroll-start, div.scroll-end{
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
div.coupling{
    width: 0.7rem;
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    text-align: center;
    font-style: normal;
}
div.text-center{
    width: 0.5rem;
    font-weight: bold;
    font-size: 0.22rem;
    color: #000000;
    text-align: center;
    font-style: normal;
}
div.scroll-start div.text-center, div.scroll-end div.text-center{
    width: 0.5rem;
}

div.start-hour, div.start-minute, div.end-hour, div.end-minute{
    flex: 1;
    height: 100%;
    text-align: center;
}

div.button-items{
    width: 100%;
    height: 0.48rem;
    margin-top: 0.4rem;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
}
div.button-submit, div.button-close{
    width: 1.4rem;
    height: 0.48rem;
    border-radius: 0.38rem;
    border: 0.02rem solid #000000;
    font-size: 0.16rem;
    line-height: 0.43rem;
    text-align: center;
}

div.button-close{
    background: #FFFFFF;
    box-shadow: inset 0 -0.05rem 0 0 #9F9F9F;
    color: #000000;
}
div.button-submit{
    background: #FC8470;
    box-shadow: inset 0 -0.05rem 0 0 #FFF4C9;
    color: #FFFFFF;
}
</style>